import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';

declare var Swiper: any;
declare var $:any;
@Component({
  selector: 'social',
  templateUrl: './social.html',
})
export class SocialComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute

  ) {

  }
    public baseRoom
    public menuOpen=true;
    public menuConfig={};
    public items:any[] = [  ];
    public roomName='';
    public option='social'

    public threedroom='1752341543384';
    public twodroom='1626799638931';

    public openContacts(){
      $('#jitsi-control-tutorial').click();
      if (this._appData.instagramUser && isNaN(this._appData.instagramUser.uid)){
        let idx=$("#profileModal")
        this._appData.tiping=true;
        idx.modal('show');
      }
      else{
        $('#registerSocialModal').modal('show')
        this._appData.tiping=true;

      }
    }

    addComment(){
      let comment=  document.getElementById('commentPlaceholder')['value']
      let date=new Date();
      let time=date.getTime()
      let commentObj={
        time:time,
        comment:comment,
        user:{uid:this._appData.instagramUser.uid,
          name:this._appData.instagramUser.full_name,
          profile_picture:this._appData.instagramUser.profile_picture},
        uid:this._appData.instagramUser.uid
      }     
      this._appData.comments.push(commentObj);
      this._companyService.addComment(this._appData.instagramUser,this._appData.socialRoom,commentObj)
      document.getElementById('commentPlaceholder')['value']='';
    }
    chooseMenu(option){
      this._appData.target=null;
      this.option=option
    }
  ngOnDestroy(): void {
      
  }

  public editSocial(){
    document.getElementById("social-modal").style.display = "none";
          const modal = document.getElementById("advertising-modal");
      modal.style.display = "flex";    
      $('#advertising-reload').click(); 
  }
  public gotoLink(){
    //this._router.navigate(['gameevent/1592880902713'], {
  //    queryParams: { room: this._appData.room.id }
//    });
    let external=null;
    if (this._appData.room && this._appData.room.link && this._appData.room.link.length>0){
      external=this._appData.room.link
    }
    else if (this._appData.room.background2d && this._appData.room.background2d.length>0){
      external='https://liveplanet.com.br/gameevent/1592880902713?room='+this._appData.room.id
    }
    else{
      this.loadRoom(this._appData.room);
    }

    this.closeModal();
    if (!external){
      const modal3 = document.getElementById("iframeOfGame");
      modal3.style.visibility = "visible";              
    }
    else{
      const modal3 = document.getElementById("iframeOfGameOut");
      modal3.style.visibility = "visible";              
      modal3['src']=external
    }
              const modal1 = document.getElementById("gameWrapper");
              modal1.style.height = "100%";    
              const modal2 = document.getElementById("minimizeIframe");
              modal2.style.visibility = "visible";              
              

  }
  loadRoom(room){
      const modal0 = document.getElementById("iframeOfGameExt");
      modal0.style.visibility = "hidden";    
              if ((room.background2d && room.background2d.length>0) ){

                const modal3 = document.getElementById("iframeOfGame");
                modal3.style.visibility = "hidden";              

                const modal2 = document.getElementById("iframeOfGameimg");
                modal2.style.visibility = "visible";              
                const modal = document.getElementById("social-modal");
                modal.style.display = "flex";              

              }
              else{
//                let modal3 = document.getElementById("iframeOfGame");
  //              modal3.style.visibility = "visible";              

                const modal4 = document.getElementById("iframeOfGameimg");
                modal4.style.visibility = "hidden";   
                const event = new CustomEvent('angularMessage',{detail:{kind:'reloadRoom',room:room}});
                window.dispatchEvent(event);
                const modal = document.getElementById("social-modal");
                modal.style.display = "flex";              

              }

  }
  public likeRoom(){
    this._companyService.likeRoom(this._appData.instagramUser,this._appData.socialRoom)
  }
  ngOnInit(): void {
     this._companyService.getRoom('1752341543384').get().then((roomd) => {
        this.baseRoom=roomd.data();
     })

              document.getElementById('iframeModal').style.top='-1000px'
              setTimeout(()=>{
                document.getElementById('iframeModal').style.top='30vh'
              },5000)

      window.addEventListener('roomReady', (event : any)=>{
//      setTimeout(()=>{
        this._appData.lazyLoadComplete=true
        document.getElementById('main').style.backgroundColor='white';
              let d=document.getElementById('gameWrapper')
              d.style.position='absolute'
              d.style.height='290px'        
  //    },10000); 
      })
      let user=null;
      if (typeof window !== "undefined" && localStorage) {
        user=localStorage.getItem('instagramUser');


      }
      if (user=="undefined"){
        user=null;
      }
      if (user){
        this._appData.instagramUser=JSON.parse(user);
      }
      this._companyService.getAuth().onAuthStateChanged(
        user => {
          if (user) {
            // User is signed in.
            console.log(user)
          } else {
            // No user is signed in.
//            $('#registerSocialModal').modal('show')
  //          this._appData.tiping=true;
          }
        },
        // Prevent console error
        error => {
    //      $('#registerSocialModal').modal('show')
      //    this._appData.tiping=true;
        }
      );
      this.mobile=this.checkMobile();
      if (this.mobile){
//        document.getElementById('menu-bar').style.visibility='hidden';
        document.getElementById('sidebar').classList.add('active');

      }
      this._routeParams.queryParams.subscribe(params => {
              var uid = params['uid'];
              this._appData.target=uid;
              this.option='profile';

            })
  }
  public mobile
  public checkMobile(){
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    if (!check){
      this.mobile=false;
      this._appData.isMobile=false;
    }
    else{
      this.mobile=true;
      this._appData.isMobile=true;

    }
    return check;
  }
  closeModal(){
    document.getElementById("social-modal").style.display = "none";
  }
  maximizeIframe(){
    let modal=document.getElementById("social-modal-subdiv");
    modal.style.width='100%'
    modal.style.height='100%';
    modal.style.maxWidth= '100vw';
    document.getElementById('minimizeIframe').style.visibility='visible';
    document.getElementById('maximizeIframe').style.visibility='hidden';
    
    
                  let d=document.getElementById('gameWrapper')
              d.style.position=''
              d.style.height='100vh'        

    let iframe = document.getElementById('iframeOfGame');
    if (iframe) {
        iframe.style.height = '100vh';
    }

  }
  minimizeIframe(){
              const modal3 = document.getElementById("iframeOfGame");
              modal3.style.visibility = "hidden";              
              const modal4 = document.getElementById("iframeOfGameOut");
              modal4.style.visibility = "hidden";              

              const modal1 = document.getElementById("gameWrapper");
              modal1.style.height = "100%";    
              const modal2 = document.getElementById("minimizeIframe");
              modal2.style.visibility = "hidden";

              
              document.getElementById('iframeModal').style.top='-1000px'
              const event = new CustomEvent('angularMessage',{detail:{kind:'reloadRoom',room:this.baseRoom}});
              window.dispatchEvent(event);
              setTimeout(()=>{
                document.getElementById('iframeModal').style.top='30vh'
              },3000)
/*    let modal=document.getElementById("social-modal-subdiv");
    modal.style.width='90%'
    modal.style.height='600px';
    modal.style.maxWidth= '900px';
    document.getElementById('minimizeIframe').style.visibility='hidden';
    document.getElementById('maximizeIframe').style.visibility='visible';
    let iframe = document.getElementById('iframeOfGame');
              let d=document.getElementById('gameWrapper')
              d.style.position='absolute'
              d.style.height='390px'
    if (iframe) {
        iframe.style.height = '390px';
    }*/
  }  
  reloadUser(){
    this.option='profile';
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/social.ts